<script>
export default {
    name: 'CardKBMapping',
    props: {
        card: Object
    },
    computed: {
        mapping () {
            return this.card.config.mapping
        },
        mappingInput () {
            return this.mapping.input
        },
        mappingMatch () {
            return this.mapping.match
        },
        mappingOutput () {
            return this.mapping.output
        },
        inputEntities () {
            return this.mappingInput.entities
        },
        outputEntities () {
            return this.mappingOutput.entities
        },
        matchEntities () {
            return typeof this.mappingMatch.required_entities === 'string' ? JSON.parse(this.mappingMatch.required_entities) : this.mappingMatch.required_entities
        },
        matchInputEntities () {
            return this.mappingMatch.input_entities
        }
    }
}
</script>

<template>
    <div class="d-flex flex-column" style="gap: 12px">
        <i class="font-weight-bold">Input:</i>
        <div class="d-flex" style="gap: 8px">Intent:
            <div class="intent-item">{{ mappingInput.intent }}</div>
        </div>
        <span>Entities:</span>
        <el-table border :data="inputEntities" show-overflow-tooltip>
            <el-table-column
                prop="entity"
                label="Loại thực thể">
            </el-table-column>
            <el-table-column
                prop="value"
                label="Giá trị">
            </el-table-column>
            <el-table-column
                prop="real_value"
                label="Giá trị thực">
            </el-table-column>
        </el-table>
        <v-divider/>
        <i class="font-weight-bold">Match:</i>
        <div class="d-flex" style="gap: 8px">Intent:
            <div class="intent-item">{{ mappingMatch.intent }}</div>
        </div>
        <div class="d-flex" style="gap: 8px">Contains Entity type:
            <div class="intent-item" v-for="(item, idx) of matchEntities" :key="idx">
                {{ item }}
            </div>
        </div>
        <div>Contains Entity value:</div>
        <el-table border :data="matchInputEntities" show-overflow-tooltip>
            <el-table-column
                prop="key"
                label="Khóa">
            </el-table-column>
            <el-table-column
                prop="op"
                label="Điều kiện">
            </el-table-column>
            <el-table-column
                prop="value"
                label="Giá trị">
            </el-table-column>
        </el-table>
        <v-divider/>
        <i class="font-weight-bold">Output:</i>
        <div class="d-flex" style="gap: 8px">Intent:
            <div class="intent-item">{{ mappingOutput.intent }}</div>
        </div>
        <span>Entities:</span>
        <el-table border :data="outputEntities" show-overflow-tooltip>
            <el-table-column
                prop="entity"
                label="Loại thực thể">
            </el-table-column>
            <el-table-column
                prop="value"
                label="Giá trị">
            </el-table-column>
            <el-table-column
                prop="real_value"
                label="Giá trị thực">
            </el-table-column>
        </el-table>
    </div>
</template>

<style scoped lang="scss">
.intent-item {
    border-radius: 4px;
    background: #D7E3FC;
    padding: 0px 6px;
    color: #204084;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 250px;
}

table {
    border-collapse: collapse;

    td {
        padding: 4px 8px;
    }
}

.entity-table-header {
    background-color: #EDEDED;

    th {
        border-bottom: 1px solid #d6d6d6;
        padding: 4px 8px;
    }
}
</style>
